/* ------------------------------------------------------------------------------
@name: ustomer
--------------------------------------------------------------------------------- */

// --- variables
import { API_URL, BASE_URL } from "variables";

// --- utilities
import { DataTable, Form, HttpRequest, SweetAlert } from "utilities";

// Form Validation
const ElementSelector = [
  {
    id: "customer_id",
  },
  {
    id: "customer_name",
    validation: {
      required: true,
    },
  },
  {
    id: "customer_phone",
    validation: {
      required: true,
      phone: true,
      invalid: true,
    },
  },
  {
    id: "address",
    validation: {
      required: true,
    },
  },
  {
    id: "map",
  },
];

const ElementEvents = ["input", "blur"];

const Customer = (() => {
  // Handle Run DataTable
  const handleRunDataTable = () => {
    const dataSetting = {
      selector: "js-data-customer",
      url: API_URL.customerGet,
      method: "POST",
      responsive: {
        breakpoints: [
          { name: "desktop", width: Infinity },
          { name: "tablet", width: 1024 },
          { name: "mobile", width: 0 },
        ],
        details: {
          type: "column",
          target: 0,
        },
      },
    };

    const filterSetting = [
      {
        id: "dateRange",
        event: "change",
      },
      {
        id: "status",
        event: "change",
      },
      {
        id: "search",
        event: "keyup",
      },
    ];

    const columnSetting = [
      {
        targets: 0,
        className: "dt-control",
        orderable: false,
        data: null,
        defaultContent: "",
        responsivePriority: 1,
        visible: false,
      },
      {
        targets: 2,
        responsivePriority: 2,
      },
      {
        targets: [1, 3, 4, 5, 6],
        // className: "desktop-only",
        responsivePriority: 10000,
      },
      {
        targets: 7,
        responsivePriority: 3,
        className: "text-center",
        render: (data) => {
          let icon_status = data.status === "1" ? "ph-eye" : "ph-eye-slash";
          return `<div class="action-order"><button type="button" data-toggle="tooltip" data-placement="left" title="Status" class="btn btn-sm btn-default btn-trans waves-effect js-update-status" data-id="${data.id}" data-status="${data.status}"><i class="ph ${icon_status}"></i></button>
          <a href="${BASE_URL}customer/detail/${data.id}" data-toggle="tooltip" data-placement="left" title="Detail" class="btn btn-sm btn-default btn-trans waves-effect js-detail-data" data-id="${data.id}"><i class="ph ph-magnifying-glass-plus"></i></a>
          <button type="button" data-toggle="tooltip" data-placement="left" title="Edit" class="btn btn-sm btn-default btn-trans waves-effect js-edit-data" data-id="${data.id}"><i class="ph ph-pencil-simple"></i></button>
					<button type="button" data-toggle="tooltip" data-placement="left" title="Delete" class="btn btn-sm btn-danger btn-trans waves-effect js-delete-data" data-id="${data.id}"><i class="ph ph-trash"></i></button></div>`;
        },
      },
    ];

    DataTable.custom(dataSetting, filterSetting, columnSetting);
  };

  // Handle Run Validation
  const handleRunValidation = () => {
    Form.validation(ElementEvents, ElementSelector);
  };

  // Handle Click Validation
  const handleClickValidation = () => {
    $('.js-form-customer button[type="submit"]').on("click", (e) => {
      e.preventDefault();

      $.each(ElementSelector, (i, v) => {
        $("#" + v.id).blur();
      });

      if ($(".error").length === 0) {
        handlePostData();
      }
    });
  };

  // handleEmptyInput
  const handleEmptyInput = () => {
    $('.js-form-customer button[data-dismiss="modal"]').on("click", (e) => {
      Form.emptyData(ElementSelector);
    });
  };

  // handlePostData
  const handlePostData = () => {
    const formData = Form.dataColletion(ElementSelector);

    let apiUrl = API_URL.customerAdd;
    if ($("#customer_id").val().length !== 0) {
      apiUrl = API_URL.customerEdit;
    }

    const data = {
      url: apiUrl,
      method: "POST",
      data: formData,
      elementSelector: ElementSelector,
    };

    let response = HttpRequest.custom(data);
    console.log(response);

    if (response.code === 200) {
      $(".modal").modal("hide");
      Form.emptyData(ElementSelector);

      if ($(".js-form-order").length > 0) {
        $(".js-input-customer").val(response.data.name);
        $(".js-input-customer").attr("data-id", response.data.id);
        $(".js-input-phone").val(response.data.phone);
      } else {
        SweetAlert.config(response.message, "success");
        $("#dataTable").DataTable().ajax.reload();
      }
    }
  };

  const handleGetFormData = () => {
    $("body").on("click", ".js-edit-data", (e) => {
      const _this = $(e.currentTarget);
      let formData = new FormData();
      const id = _this.attr("data-id");
      formData.append("customer_id", id);

      const data = {
        url: API_URL.customerGet,
        method: "POST",
        data: formData,
        elementSelector: ElementSelector,
      };

      Form.getFormData(data);
    });
  };

  // handleDeleteData
  const handleDeleteData = () => {
    $("body").on("click", ".js-delete-data", (e) => {
      const _this = $(e.currentTarget);
      let formData = new FormData();
      const id = _this.attr("data-id");
      console.log(id);

      formData.append("customer_id", id);

      const data = {
        url: API_URL.customerDelete,
        method: "POST",
        data: formData,
      };

      Form.deleteData(data);
    });
  };

  function clearCustomerSelection($input) {
    const $el = $input instanceof jQuery ? $input : $($input);
    const $parent = $el.closest(".form-dropdown");

    // clear visible input and stored id
    $parent.find(".form-dropdown-input").val("").removeAttr("data-id");

    // hide reset button if present
    $parent.find(".js-reset-dropdown").hide();

    // clear phone input (assumes single phone field)
    $(".js-input-phone").val("");

    // clear suggestion list if present
    $parent.find(".js-list-customer").empty();

    // remove dropdown/show/error classes
    $parent.removeClass("form-dropdown-show error");
    $parent.find(".error").removeClass("error");

    // trigger change for any listeners
    $parent.find(".form-dropdown-input").trigger("change");
  }

  /**
   * Toggle customer status (active/disabled).
   * Uses data-id and data-status attributes on the clicked element.
   */
  const handleUpdateStatus = () => {
    // use event delegation with namespaced event
    $("body").off("click.handleUpdateStatus", ".js-update-status");
    $("body").on("click.handleUpdateStatus", ".js-update-status", function (e) {
      e.preventDefault();
      const $btn = $(this);
      const id = $btn.attr("data-id");
      // parse status as integer; fallback to 0 if missing
      let status = parseInt($btn.attr("data-status"), 10);
      if (!Number.isFinite(status)) status = 0;

      // toggle: if 0 -> 1, else -> 0
      const newStatus = status === 0 ? 1 : 0;

      // Optional: optimistic UI toggle (comment out if you prefer server confirmation)
      // $btn.attr("data-status", String(newStatus));
      // $btn.toggleClass("is-active", newStatus === 1);

      const formData = new FormData();
      formData.append("customer_id", id);
      formData.append("status", String(newStatus));

      const data = {
        url: API_URL.customerEdit,
        method: "POST",
        data: formData,
      };

      // if Form.updateStatus returns a promise or accepts callbacks, handle success/failure to update UI
      try {
        const res = Form.updateStatus(data);
        // if updateStatus returns a Promise, update attribute on success
        if (res && typeof res.then === "function") {
          $btn.prop("disabled", true);
          res
            .then((resp) => {
              $btn.prop("disabled", false);
              // reflect server-acknowledged status
              $btn.attr("data-status", String(newStatus));
              $btn.toggleClass("is-active", newStatus === 1);
            })
            .catch((err) => {
              $btn.prop("disabled", false);
              console.error("Failed to update status", err);
              // optionally show toast/error
            });
        } else {
          // If not a promise, still update attribute optimistically
          $btn.attr("data-status", String(newStatus));
          $btn.toggleClass("is-active", newStatus === 1);
        }
      } catch (err) {
        console.error("Form.updateStatus error", err);
      }
    });
  };

  /**
   * Customer select / autocomplete handlers.
   * - Clears linked fields when input becomes empty (via keyboard/delete/paste/cut)
   * - Shows suggestions when typing
   * - Handles reset button click and selection from suggestion list
   */
  const handleSelectCustomer = () => {
    // ensure handlers are not duplicated
    $(".js-input-customer").off(".selectCustomer");

    // input: show suggestions or clear when emptied
    $(".js-input-customer").on("input.selectCustomer", function (e) {
      const $this = $(this);
      const val = String($this.val() || "");

      if (!val.trim()) {
        // input emptied by keyboard/backspace/delete -> clear linked values
        clearCustomerSelection($this);
        return;
      }

      // show reset button if present
      const $parent = $this.closest(".form-dropdown");
      $parent.find(".js-reset-dropdown").show();

      // fetch suggestions (handlerGetCustomer should handle empty or query)
      handlerGetCustomer(val);
    });

    // cut / paste: wait for value to be updated, then check empty
    $(".js-input-customer").on(
      "cut.selectCustomer paste.selectCustomer",
      function () {
        const $this = $(this);
        setTimeout(() => {
          if (!String($this.val() || "").trim()) {
            clearCustomerSelection($this);
          } else {
            // show suggestions for new value
            handlerGetCustomer(String($this.val() || ""));
          }
        }, 1);
      }
    );

    // focus: request suggestions (may show recent items)
    $(".js-input-customer").on("focus.selectCustomer", function () {
      const $this = $(this);
      handlerGetCustomer(String($this.val() || ""));
    });

    // reset button: clear inputs and linked fields
    $(".js-reset-dropdown")
      .off("click.selectCustomer")
      .on("click.selectCustomer", function (e) {
        e.preventDefault();
        const $this = $(this);
        const $parent = $this.closest(".form-dropdown");
        $parent.find(".form-dropdown-input").val("").removeAttr("data-id");
        $parent.find(".js-reset-dropdown").hide();
        $parent.find(".form-dropdown-input").focus();
        $parent.find(".js-list-customer").empty();
        $(".js-input-phone").val("");
        $parent.removeClass("form-dropdown-show error");
        $parent.find(".error").removeClass("error");
        // notify change
        $parent.find(".form-dropdown-input").trigger("change");
      });

    // selection from suggestion list: set values and linked phone
    $("body").off(
      "click.selectCustomer",
      ".js-list-customer .form-dropdown-select"
    );
    $("body").on(
      "click.selectCustomer",
      ".js-list-customer .form-dropdown-select",
      function (e) {
        e.preventDefault();
        const $this = $(this);
        const value = $this.attr("data-value") || $this.text().trim();
        const id = $this.attr("data-id") || "";
        const phone = $this.attr("data-phone") || "";

        const $parent = $this.closest(".form-dropdown");
        $parent.find(".form-dropdown-input").val(value).attr("data-id", id);
        $parent.find(".js-reset-dropdown").show();
        $(".js-input-phone").val(phone);

        $parent.removeClass("form-dropdown-show error");
        $parent.find(".error").removeClass("error");
        // notify change
        $parent.find(".form-dropdown-input").trigger("change");
      }
    );
  };

  // handlerGetCustomer
  const handlerGetCustomer = (search = 0) => {
    $.ajax({
      url: API_URL.customerGet,
      method: "POST",
      dataType: "JSON",
      data: {
        search: search,
      },
      success: (response) => {
        const _data = response.data;

        let _content = "";
        $.each(_data, (i, v) => {
          _content += `<li class="form-dropdown-item">
                          <span class="form-dropdown-select" data-value="${v.name}" data-id="${v.id}" data-phone="${v.phone}">
                            ${v.name}
                          </span>
                        </li>`;
        });

        if (_data.length === 0) {
          _content = `<li class="form-dropdown-notif">Data not found!</li>`;
        }

        $(".js-list-customer").html(_content);
      },
    });
  };

  // init
  const init = () => {
    if ($(".js-data-customer").length) {
      handleRunDataTable();
      handleDeleteData();
      handleGetFormData();
      handleUpdateStatus();
    }
    if ($(".js-form-customer").length) {
      handleRunValidation();
      handleClickValidation();
      handleEmptyInput();
    }
    if ($(".js-list-customer").length) {
      handleSelectCustomer();
    }
  };

  return {
    init,
  };
})();

export default Customer;
